import React from "react";
import _ from "lodash";
import LinkIconSVG from "assets/svg/link-icon";
import VideoEmbedIconSVG from "assets/svg/video-embed-icon";
import VideoFileIconSVG from "assets/svg/video-file-icon";
import AudioIconSVG from "assets/svg/audio-icon";
import ImageIconSVG from "assets/svg/image-icon";
import TextIconSVG from "assets/svg/text-icon";
import { useTranslation } from "react-i18next";


const AddButtonListItem = ({
  closeMoreOption = ()=>{},
  ...props
}) => {

const {t} = useTranslation();

  return (
    <div className="flex flex-col shadow-lg rounded-md bg-white">
      <ul className="font-semibold">
            <li className="hover:bg-gray hover:rounded-t-md" >
              <button
                className="flex flex-row items-center text-base px-4 py-2"
                onClick={() => {closeMoreOption('Link');}}>
                  <LinkIconSVG className="w-6 h-6 mr-3" />
                  {t('link')}
              </button>
            </li>
            <li className="hover:bg-gray hover:rounded-t-md" >
              <button
                className="flex flex-row items-center text-base px-4 py-2"
                onClick={() => {closeMoreOption('Video Embed');}}>
                  <VideoEmbedIconSVG className="w-6 h-6 mr-3" />
                {t('videoEmbed')}
              </button>
            </li>
            <li className="hover:bg-gray hover:rounded-t-md" >
              <button
                className="flex flex-row items-center text-base px-4 py-2"
                onClick={() => {closeMoreOption('Audio File');}}>
                  <AudioIconSVG className="w-6 h-6 mr-3" />
                  {t('audioFile')}
              </button>
            </li>
            <li className="hover:bg-gray hover:rounded-t-md" >
              <button
                className="flex flex-row items-center text-base px-4 py-2"
                onClick={() => {closeMoreOption('Images');}}>
                  <ImageIconSVG className="w-6 h-6 mr-3" />
                  {t('image')}
              </button>
            </li>
            <li className="hover:bg-gray hover:rounded-t-md" >
              <button
                className="flex flex-row items-center text-base px-4 py-2"
                onClick={() => {closeMoreOption('Read');}}>
                  <TextIconSVG className="w-6 h-6 mr-3" />
                  {t('pdf')}
              </button>
            </li>
      </ul>
    </div>
  );
};

export default AddButtonListItem;
